import React from 'react';

const SliderHorizontalIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.16797 13.7526V6.2526C4.16797 5.73594 4.18464 5.2776 4.24297 4.86927C4.48464 2.6776 5.51797 2.08594 8.33464 2.08594H11.668C14.4846 2.08594 15.518 2.6776 15.7596 4.86927C15.818 5.2776 15.8346 5.73594 15.8346 6.2526V13.7526C15.8346 14.2693 15.818 14.7276 15.7596 15.1359C15.518 17.3276 14.4846 17.9193 11.668 17.9193H8.33464C5.51797 17.9193 4.48464 17.3276 4.24297 15.1359C4.18464 14.7276 4.16797 14.2693 4.16797 13.7526Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M1.66797 16.25V3.75" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M18.332 15.8359V3.33594" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default SliderHorizontalIcon;
